export const blockIconsImageEdit = (
	<span className='material-symbols-outlined'>edit</span>
);
